<template>
  <div>
    <CountDownTimer
      class="timer"
      v-if="step !== 1"
      :style="{ top: `${appBarHeight}px` }"
    ></CountDownTimer>
    <div
      class="white titleBar"
      id="titleBar"
      :style="{ visibility: showTitleBanner ? 'visible' : 'hidden' }"
    >
      <CustomRow>
        <div
          class="text-page-title py-3 titleBanner text-sm-massive-title font-weight-bold is-word-break"
        >
          {{ session.name }}
          <v-spacer />
        </div>
      </CustomRow>
    </div>
    <div class="white" id="banner">
      <CustomRow>
        <v-row class="py-3 my-0">
          <v-col cols="12" sm="6" md="4" align-self="center">
            <v-img
              v-if="!!campaign.picBigActiveThumbnail"
              :src="`${campaign.picBigActiveThumbnail}`"
              class="rounded-lg"
            ></v-img>
            <v-sheet
              v-else
              height="300"
              class="rounded-xl"
              color="grey lighten-1"
            />
          </v-col>
          <v-col cols="12" sm="6" md="8" align-self="center">
            <div class="px-2 text-nine">
              <div>
                <template v-for="tag in campaign.tags"> #{{ tag }} </template>
              </div>
              <div
                class="mt-2 text-page-title text-sm-massive-title font-weight-bold"
              >
                {{ session.name }}
              </div>
              <v-divider class="my-3" />
              <div class="my-2 d-flex">
                <div>
                  <v-icon color="#444444" class="mr-2" small
                    >mdi-calendar</v-icon
                  >
                </div>
                <div>
                  {{ sessionDate }}
                </div>
              </div>
              <div class="my-2 d-flex">
                <div>
                  <v-icon color="#444444" class="mr-2" small
                    >mdi-clock-outline</v-icon
                  >
                </div>
                <div class="is-word-break">
                  {{ sessionTime }}
                </div>
              </div>
              <div class="my-2 d-flex">
                <div>
                  <v-icon color="#444444" class="mr-2" small
                    >mdi-map-marker</v-icon
                  >
                </div>
                <div>
                  {{ session.location }}
                  <span v-if="session.address">
                    ( {{ session.address }} )
                  </span>
                </div>
              </div>
              <div class="my-2 d-flex">
                <div>
                  <v-icon color="#444444" class="mr-2" small>mdi-domain</v-icon>
                </div>
                <div>
                  <template v-for="(host, i) in session.hosts">
                    {{ host }}
                    <span v-if="i !== session.hosts.length - 1" :key="i">
                      、
                    </span>
                  </template>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </CustomRow>
    </div>

    <div class="order-content">
      <CustomRow>
        <template v-if="!$vuetify.breakpoint.xs">
          <div class="d-flex justify-center align-center stepperPadding">
            <template v-for="(value, i) in steps">
              <v-btn
                fab
                depressed
                :class="stepStatus(i + 1)"
                class="mr-2 stepNum"
                :key="`stepNum-${i}`"
              >
                <v-icon color="white" v-if="step > i + 1">mdi-check</v-icon>
                <template v-else>{{ i + 1 }}</template>
              </v-btn>
              <div
                :class="stepStatus(i + 1)"
                class="stepText"
                :key="`stepText-${i}`"
              >
                {{ value }}
              </div>
              <v-divider
                class="mx-3 stepDivider"
                :class="stepStatus(i + 1)"
                v-if="i !== steps.length - 1"
                :key="`stepDivider-${value}`"
              ></v-divider>
            </template>
          </div>
        </template>
        <template v-else>
          <div class="px-5">
            <div class="d-flex justify-center align-center stepperPadding">
              <template v-for="(value, i) in steps">
                <v-btn
                  fab
                  depressed
                  :class="stepStatus(i + 1)"
                  class="stepNum"
                  :key="i"
                >
                  <v-icon color="white" v-if="step > i + 1">mdi-check</v-icon>
                  <template v-else>{{ i + 1 }}</template>
                </v-btn>
                <v-divider
                  class="stepDivider"
                  :class="stepStatus(i + 1)"
                  v-if="i !== steps.length - 1"
                  :key="value"
                ></v-divider>
              </template>
            </div>
            <div class="d-flex justify-space-between align-center mt-2">
              <div
                v-for="(value, i) in steps"
                :class="stepStatus(i + 1)"
                class="stepText"
                :key="i"
              >
                {{ value }}
              </div>
            </div>
          </div>
        </template>

        <v-card
          v-if="step <= 3"
          :class="
            `py-5 mt-4 mt-md-10 ${session.ticketArea ? 'has-ticketarea' : ''}`
          "
        >
          <slot name="stepCard" />
        </v-card>
        <slot name="Contents" />
        <v-card
          v-if="(step === 3 && steps.length === 3) || step === 4"
          class="py-5 mt-4 mt-md-10"
        >
          <slot name="paymentSummary" />
          <slot name="orderRecaptcha" />
        </v-card>
      </CustomRow>
    </div>

    <div class="order-footer">
      <CustomRow>
        <v-row no-gutters class="py-3">
          <slot name="orderFooter" />
        </v-row>
      </CustomRow>
    </div>
  </div>
</template>

<script>
import CountDownTimer from "./components/CountDownTimer.vue";
import { mapGetters, mapActions } from "vuex";
import { orderCheckLoginMixins } from "@/shared/mixins";

export default {
  components: { CountDownTimer },
  props: {
    steps: {
      default: [],
      type: Array
    },
    step: {
      default: 1,
      type: Number
    }
  },
  mixins: [orderCheckLoginMixins],
  data() {
    const dt = new Date();
    const timeString = `${dt.getFullYear()}/${dt.getMonth() +
      1}/${dt.getDate()} ${dt.getHours()}:${dt.getMinutes()}`;
    return {
      showTitleBanner: true,
      titleBarHeight: 0,
      appBarHeight: 0
    };
  },
  watch: {
    session: {
      deep: true,
      handler(newVal) {
        if (newVal.name) {
          this.$nextTick(() => {
            this.titleBarHeight = document.getElementById(
              "titleBar"
            ).clientHeight;
          });
        }
      }
    },
    campaign(newVal) {
      this.$emit("getCampaign", newVal);
    }
  },
  computed: {
    ...mapGetters({
      campaign: "event/campaign",
      session: "session/sessionInfo"
    }),
    sessionDate() {
      if (!this.session.date) {
        return "";
      } else {
        if (this.session.date.indexOf("~") > -1) {
          const dt = this.session.date.split(" ~ ");
          return dt[0] === dt[1] ? dt[0] : `${dt[0]} ~ ${dt[1]}`;
        } else {
          return this.session.date;
        }
      }
    },
    sessionTime() {
      if (!this.session.time) {
        return "";
      } else {
        if (this.session.time.indexOf("~") > -1) {
          const dt = this.session.time.split(" ~ ");
          return dt[0] === dt[1] ? dt[0] : `${dt[0]} ~ ${dt[1]}`;
        } else {
          return this.session.time;
        }
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  async mounted() {
    this.appBarHeight = document.getElementById("appBar").clientHeight;
    this.showTitleBanner = false;
  },
  methods: {
    handleScroll() {
      // 處理滾動
      let curr_offset = window.scrollY.toFixed(0);

      // show NavView
      if (
        curr_offset >
        document.getElementById("banner").clientHeight - this.titleBarHeight
      ) {
        this.showTitleBanner = true;
      } else {
        this.showTitleBanner = false;
      }
    },
    stepStatus(index) {
      if (this.step == index) return "currStep";
      if (this.step > index) return "checkedStep";
      else return "afterStep";
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="scss" scoped>
.connect-line {
  margin: auto;
}

.titleBar {
  position: fixed;
  width: 100%;
  z-index: 4;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
}

.timer {
  position: sticky;
  width: 100%;
  z-index: 1;
}

.order-content {
  padding-bottom: 96px;
}

.order-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: white;
  box-shadow: 0 -3px 10px 0 rgba(0, 0, 0, 0.15);
  z-index: 5;
}

::v-deep .v-stepper__step__step {
  height: 40px;
  width: 40px;
  font-size: 18px;
}

@media screen and (max-width: 600px) {
  ::v-deep .v-stepper__step__step {
    height: 28px;
    width: 28px;
    font-size: 16px;
  }
}

::v-deep .v-stepper__label {
  font-weight: bold;
}

// .v-stepper__header {
//   height: 90px;
//   padding: 0 50px;
// }

.stepperPadding {
  padding: 40px 100px 0 100px;

  @media screen and (max-width: 600px) {
    padding: 16px 16px 0 16px;
  }

  @media only screen and (min-width: 600px) and (max-width: 960px) {
    padding: 40px 40px 0 40px;
  }
}

.stepNum {
  width: 45px;
  height: 45px;

  @media screen and (max-width: 960px) {
    width: 40px;
    height: 40px;
  }

  font-size: 20px;

  &.currStep {
    background-color: white !important;
    color: $primary-1;
    border: 3px solid $primary-1;
  }

  &.checkedStep {
    background-color: $primary-1 !important;
    color: white;
  }

  &.afterStep {
    background-color: #c4c4c4 !important;
    color: white;
  }
}

.stepText {
  font-size: 1.2rem;
  font-weight: bold;

  @media screen and (max-width: 960px) {
    font-size: 18px;
  }

  @media screen and (max-width: 600px) {
    font-size: 16px;
    width: 25%;
    text-align: center;
    // padding: 0 4px;
  }

  &.currStep {
    color: $primary-1;
  }

  &.checkedStep {
    color: #444444;
  }

  &.afterStep {
    color: #c4c4c4;
  }
}

.stepDivider {
  border-top: 2px solid #c4c4c4;

  &.checkedStep {
    border-top: 2px solid $primary-1;
  }
}
</style>
